import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './CustomerBasic.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import {MyInput} from './Utilities/MyInput';

import MyTooltip from '../components/Utilities/MyTooltip';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function CustomerBasic(prop) {	
	const navigate = useNavigate();
	
	let userId = prop.userId
	const [fetchCompleted, setFetchCompleted] = useState(true);
	const [resetingPw, setResetingPw] = useState(false);
	
	const [newPw, setNewPw] = useState("12345678");
	
	const [nickname, setNickname] = useState(null);
	const [phone, setPhone] = useState(null);
	const [district, setDistrict] = useState(null);
	const [readingLevel, setReadingLevel] = useState(null);
	const [speakingLevel, setSpeakingLevel] = useState(null);
	const [listeningLevel, setListeningLevel] = useState(null);
	const [wordBankLevel, setWordBankLevel] = useState(null);
	
	
	
	const tmpChangePassword = async() => {		
		if (resetingPw) {
			return;
		}
		setResetingPw(true);
		let obj = {
			userId
		}
		
		postData("customerApi/tmpChangePassword", obj, navigate); 
		
		await new Promise(resolve => setTimeout(resolve, 10000));
		
		setResetingPw(false);
	}
	
	const toggleIsCN = async() => {		
		let obj = {userId}
		if (district == 'china') {
			setDistrict(null);
			obj.district = null;
		} else {
			setDistrict('china');
			obj.district = 'china';
		}
		
		postData("customerApi/toggleIsCN", obj, navigate); 
	}
	const changePassword = async() => {		
		let obj = {userId, password:newPw}
		
		postData("customerApi/changePassword", obj, navigate); 
	}
	
	const processSetNickname = async(nickname) => {		
		setNickname(nickname);
		
		let obj = {userId, nickname}
		
		postData("customerApi/changeNickname", obj, navigate); 
	}
	
	
	const processSetPhone = async(phone) => {		
		setPhone(phone);
		
		let obj = {userId, phone}
		
		postData("customerApi/changePhone", obj, navigate); 
	}
	
	const fetchData = async () => {
		let res = await getData('customerApi/getById?userId=' + userId, navigate)
		setNickname(res.data.nickname);
		setPhone(res.data.phone);
		setDistrict(res.data.district);
		setReadingLevel(res.data.readingLevel);
		setSpeakingLevel(res.data.speakingLevel);
		setListeningLevel(res.data.listeningLevel);
		setWordBankLevel(res.data.wordBankLevel);
		setFetchCompleted(true);
	}
	
	
	//done get user basic
	//reset password <= ok
	//set is CN
	//level
	
	useEffect(() => {
		fetchData();
	}, []);

	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}


	return (<div style={{display:"flex", flexDirection:"column", alignItems:"start"}}>

		<div>
			<GreenButton isEnabled={!resetingPw} clickedAction={tmpChangePassword} bText={"Tmp reset password"} />
		</div>
		<div style={{margin:"10px 0", width:"100%", 
			display:"flex", flexDirection:"column", alignItems:"start", 
			background:"#e6f4f3", padding:"10px"}}>

			
			<div style={{display:"flex", gap:"10px", alignItems:"center"}}>
				<div style={{fontWeight:"bold"}}>Nickname:</div>
				<MyInput inputLabel={""} dataInput={nickname} changeAction={
					(value) => processSetNickname(value)
				} />
			</div>
			
			
			
			
			<div style={{display:"flex", gap:"10px", alignItems:"center"}}>
				<div style={{fontWeight:"bold"}}>Phone:</div>
				<MyInput inputLabel={""} dataInput={phone} changeAction={
					(value) => processSetPhone(value)
				} />
			</div>
			<div style={{display:"flex", gap:"10px", alignItems:"center"}}>
				<div style={{fontWeight:"bold"}}>New Password:</div>
				<MyInput inputLabel={""} dataInput={newPw} changeAction={setNewPw} />
				<div>
					<GreenButton isEnabled={true} clickedAction={changePassword} bText={"Change Password"} />
				</div>
			</div>
			<div style={{display:"flex", gap:"10px", alignItems:"center", fontWeight:"bold"}}>
				<div>Current location:</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={toggleIsCN} bText={(district == 'china') ? 'CN' : "HK"} />			
				</div>	
			</div>
		</div>
	</div>);
	
}

